import React, { useState } from 'react';
import AgeWeightBarChart from './AgeWeightBarChart';
import AgeWeightPieChart from './AgeWeightPieChart';
import CostSummaryChart from './CostSummary';
// import AgeWeightPieChart from './AgeWeightPieChart';

// const AgeWeightDashboard = ({ ageWeightStats }) => {
//   const [selectedCategory, setSelectedCategory] = useState('pipe');

//   // Prepare pie chart data from total values
// //   const pieData = [
// //     { name: 'Pipe', value: ageWeightStats.pipe?.total || 0 },
// //     { name: 'Fins', value: ageWeightStats.fins?.total || 0 },
// //     { name: 'Endplate', value: ageWeightStats.endplate?.total || 0 },
// //   ];

//   const categoryColors = {
//     pipe: '#4F81BD',
//     fins: '#C0504D',
//     endplate: '#9BBB59',
//   };

//   return (
//     <div>
//       {/* Toggle buttons to switch bar chart dataset */}
//       <div style={{ marginBottom: 16 }}>
//         {['pipe', 'fins', 'endplate'].map((cat) => (
//           <button
//             key={cat}
//             onClick={() => setSelectedCategory(cat)}
//             style={{
//               marginRight: 10,
//               backgroundColor: selectedCategory === cat ? categoryColors[cat] : '#eee',
//               color: selectedCategory === cat ? '#fff' : '#000',
//               padding: '8px 16px',
//               border: 'none',
//               borderRadius: 4,
//               cursor: 'pointer',
//             }}
//           >
//             {cat.charAt(0).toUpperCase() + cat.slice(1)}
//           </button>
//         ))}
//       </div>

//       {/* Layout: Bar chart on left, Pie chart on right */}
//       <div style={{ display: 'flex', flexWrap: 'wrap', gap: 20 }}>
//         <div style={{ flex: 1, minWidth: 400 }}>
//           <AgeWeightBarChart
//             data={ageWeightStats[selectedCategory]?.grouped || []}
//             label={`Age (${selectedCategory})`}
//             barColor={categoryColors[selectedCategory]}
//           />
//         </div>
//         {/* <div style={{ flex: 1, minWidth: 400 }}>
//           <AgeWeightPieChart data={pieData} />
//         </div> */}
//       </div>
//     </div>
//   );
// };

// export default AgeWeightDashboard;



const AgeWeightDashboard = ({ data }) => {
 
    const [selectedCategory, setSelectedCategory] = useState('pipe');


    const pieData = [
        { name: 'Endplate', value: +(data.endplate?.total * 80).toFixed(2) || 0 },
        { name: 'Pipe', value: +(data.pipe?.total * 900).toFixed(2) || 0 },
        { name: 'Fins', value: +(data.fins?.total * 310).toFixed(2) || 0 },    
      ];

   
      

    if (!data || !data[selectedCategory]) {
        return <div>Loading charts...</div>;
    }

    const categoryColors = {
        pipe: '#4F81BD',
        fins: '#C0504D',
        endplate: '#9BBB59',
    };

    return (
        <div>
            {/* Toggle buttons to switch bar chart dataset */}
            <div style={{ marginBottom: 16 }}>
                {['endplate', 'pipe', 'fins'].map((cat) => (
                    <button
                        key={cat}
                        onClick={() => setSelectedCategory(cat)}
                        style={{
                            marginRight: 10,
                            backgroundColor: selectedCategory === cat ? categoryColors[cat] : '#eee',
                            color: selectedCategory === cat ? '#fff' : '#000',
                            padding: '8px 16px',
                            border: 'none',
                            borderRadius: 4,
                            cursor: 'pointer',
                        }}
                    >
                        {cat.charAt(0).toUpperCase() + cat.slice(1)}
                    </button>
                ))}
            </div>

        
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 20 }}>
                <div style={{ flex: 1, minWidth: 400 }}>
          
                    <AgeWeightBarChart
                        data={data[selectedCategory]?.grouped|| []}
                        label={`Age (${selectedCategory})`}
                        barColor={categoryColors[selectedCategory]}
                    />
                
                    <div style={{ flex: 1, minWidth: 400, textAlign: 'center' }}>
                        <h5>Total Cost</h5>
                        <AgeWeightPieChart data={pieData} />
                    </div>

                    {/* <div style={{ flex: 1, minWidth: 400, textAlign: 'center' }}>
                        <h5>Daily Update</h5>
                        <CostSummaryChart data={pieData} />
                    </div> */}

                </div>
            </div>
        </div>
    );
};
export default AgeWeightDashboard;



// import React, { useState, useEffect } from 'react';
// import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell, Sector } from 'recharts';

 

// // Age Weight Bar Chart Component
// const AgeWeightBarChart = ({ data, label, barColor }) => {
//   return (
//     <div style={{ height: 300, width: '100%' }}>
//       <h5>{label}</h5>
//       <ResponsiveContainer width="100%" height="100%">
//         <BarChart
//           data={data}
//           margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
//         >
//           <CartesianGrid strokeDasharray="3 3" />
//           <XAxis dataKey="ageRange" />
//           <YAxis />
//           <Tooltip />
//           <Legend />
//           <Bar dataKey="weight" fill={barColor} name="Weight" />
//         </BarChart>
//       </ResponsiveContainer>
//     </div>
//   );
// };

// // Age Weight Pie Chart Component
// const AgeWeightPieChart = ({ data }) => {
//   const COLORS = ['#9BBB59', '#4F81BD', '#C0504D'];
//   const [activeIndex, setActiveIndex] = useState(0);

//   const onPieEnter = (_, index) => {
//     setActiveIndex(index);
//   };

//   const renderActiveShape = (props) => {
//     const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill, payload, percent, value } = props;
    
//     return (
//       <g>
//         <text x={cx} y={cy} dy={-20} textAnchor="middle" fill={fill}>
//           {payload.name}
//         </text>
//         <text x={cx} y={cy} dy={8} textAnchor="middle" fill="#333">
//           ${value.toLocaleString()}
//         </text>
//         <text x={cx} y={cy} dy={25} textAnchor="middle" fill="#999">
//           {(percent * 100).toFixed(2)}%
//         </text>
//         <Sector
//           cx={cx}
//           cy={cy}
//           innerRadius={innerRadius}
//           outerRadius={outerRadius + 10}
//           startAngle={startAngle}
//           endAngle={endAngle}
//           fill={fill}
//         />
//       </g>
//     );
//   };

//   return (
//     <div style={{ height: 300, width: '100%' }}>
//       <ResponsiveContainer width="100%" height="100%">
//         <PieChart>
//           <Pie
//             activeIndex={activeIndex}
//             activeShape={renderActiveShape}
//             data={data}
//             cx="50%"
//             cy="50%"
//             innerRadius={60}
//             outerRadius={80}
//             dataKey="value"
//             onMouseEnter={onPieEnter}
//           >
//             {data.map((entry, index) => (
//               <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
//             ))}
//           </Pie>
//           <Tooltip formatter={(value) => `$${value.toLocaleString()}`} />
//         </PieChart>
//       </ResponsiveContainer>
//     </div>
//   );
// };

// // Main Dashboard Component
// const AgeWeightDashboard = ({ data }) => {
//   const [selectedCategory, setSelectedCategory] = useState('pipe');
//   const [ageRanges, setAgeRanges] = useState(['0-30', '30-60', '60-120']);
//   const [customData, setCustomData] = useState(data || {});
//   const [isEditing, setIsEditing] = useState(false);
//   const [tempAgeRanges, setTempAgeRanges] = useState('0-30,30-60,60-120');

//   // When ageRanges change, transform the data to match the new ranges
//   useEffect(() => {
//     if (!data) return;
    
//     // Transform the API data to match the new age ranges
//     const newData = { ...data };
    
//     Object.keys(newData).forEach(category => {
//       if (newData[category] && newData[category].grouped) {
//         newData[category] = {
//           ...newData[category],
//           grouped: ageRanges.map((range, index) => {
//             // Try to find matching data from the API, or keep existing data if available
//             const existingData = data[category].grouped.find(item => item.ageRange === range);
            
//             if (existingData) {
//               return existingData;
//             } else {
//               // If no exact match is found, use the data at the same index position if available
//               return {
//                 ageRange: range,
//                 weight: data[category].grouped[index]?.weight || 0
//               };
//             }
//           })
//         };
//       }
//     });
    
//     setCustomData(newData);
//   }, [ageRanges, data]);

//   // Calculate pie data from actual API data
//   const pieData = Object.keys(customData)
//     .filter(key => customData[key] && customData[key].total !== undefined)
//     .map(key => {
//       const multipliers = {
//         endplate: 80,
//         pipe: 900,
//         fins: 310
//       };
//       return {
//         name: key.charAt(0).toUpperCase() + key.slice(1),
//         value: +(customData[key].total * (multipliers[key] || 1)).toFixed(2)
//       };
//     });

//   const categoryColors = {
//     pipe: '#4F81BD',
//     fins: '#C0504D',
//     endplate: '#9BBB59',
//   };

//   const handleSaveRanges = () => {
//     const newRanges = tempAgeRanges.split(',').map(r => r.trim());
//     setAgeRanges(newRanges);
//     setIsEditing(false);
//   };

//   // If the selected category doesn't exist in the data, select the first available category
//   useEffect(() => {
//     if (customData && Object.keys(customData).length > 0 && !customData[selectedCategory]) {
//       setSelectedCategory(Object.keys(customData)[0]);
//     }
//   }, [customData, selectedCategory]);
  
//   // Check if data is available
//   if (!customData || Object.keys(customData).length === 0) {
//     return <div>Loading charts...</div>;
//   }

//   return (
//     <div className="p-4">
//       {/* Age Range Configuration */}
//       <div className="mb-4 p-3 bg-gray-100 rounded">
//         <h5 className="font-medium mb-2">Age Ranges</h5>
//         {isEditing ? (
//           <div className="flex flex-col space-y-2">
//             <input
//               type="text"
//               value={tempAgeRanges}
//               onChange={(e) => setTempAgeRanges(e.target.value)}
//               className="border p-2 rounded"
//               placeholder="Enter age ranges separated by commas"
//             />
//             <div className="flex space-x-2">
//               <button 
//                 onClick={handleSaveRanges}
//                 className="bg-blue-500 text-white px-4 py-1 rounded"
//               >
//                 Save
//               </button>
//               <button 
//                 onClick={() => setIsEditing(false)}
//                 className="bg-gray-300 px-4 py-1 rounded"
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         ) : (
//           <div className="flex justify-between items-center">
//             <div>Current: {ageRanges.join(', ')}</div>
//             <button 
//               onClick={() => setIsEditing(true)}
//               className="bg-gray-200 px-3 py-1 rounded text-sm"
//             >
//               Edit
//             </button>
//           </div>
//         )}
//       </div>

//       {/* Category Toggle Buttons - Dynamic based on API data */}
//       <div className="mb-4">
//         {Object.keys(customData).map((cat) => (
//           <button
//             key={cat}
//             onClick={() => setSelectedCategory(cat)}
//             style={{
//               marginRight: 10,
//               backgroundColor: selectedCategory === cat ? categoryColors[cat] || '#777' : '#eee',
//               color: selectedCategory === cat ? '#fff' : '#000',
//               padding: '8px 16px',
//               border: 'none',
//               borderRadius: 4,
//               cursor: 'pointer',
//             }}
//           >
//             {cat.charAt(0).toUpperCase() + cat.slice(1)}
//           </button>
//         ))}
//       </div>

//       {/* Charts */}
//       <div className="flex flex-wrap gap-5">
//         <div className="flex-1 min-w-lg">
//           <AgeWeightBarChart
//             data={customData[selectedCategory]?.grouped || []}
//             label={`Age (${selectedCategory})`}
//             barColor={categoryColors[selectedCategory]}
//           />
          
//           <div className="mt-6 text-center">
//             <h5 className="font-medium mb-2">Total Cost</h5>
//             <AgeWeightPieChart data={pieData} />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AgeWeightDashboard;